import React, { ReactElement } from 'react';
import './footer.scss';
import cn from 'classnames';

export interface FooterTemplateProps {
    className?: string;
    footerLinks: ReactElement;
}

const FooterTemplate: React.FunctionComponent<FooterTemplateProps> = ({
    className,
    footerLinks,
}: FooterTemplateProps): ReactElement => {
    return (
        <footer className={cn('footer', className)}>
            <section className='links'>{footerLinks}</section>
        </footer>
    );
};

export default FooterTemplate;
